// Globals
import { FC } from 'react';

// Modules
import { CreateFaqModal, TFaqFormValues } from '@/modules/FaqCommon';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { createGeneralFaq, selectGeneralFaqsIsLoading } from '../feature';

type TCreateGeneralFaqModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const CreateGeneralFaqModal: FC<TCreateGeneralFaqModalProps> = ({ isOpen, onClose }) => {
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectGeneralFaqsIsLoading);

  const handleCreateGeneralFaq = async (values: TFaqFormValues) => {
    try {
      await dispatch(createGeneralFaq(values)).unwrap();
      onClose();
    } catch {}
  };

  return <CreateFaqModal isOpen={isOpen} onClose={onClose} onSubmit={handleCreateGeneralFaq} isLoading={isLoading} />;
};

export default CreateGeneralFaqModal;
